module.exports = __webpack_public_path__ + "static/media/iPhone-test2.9d1c27ce.svg";